module.exports = "query GetPromptingsAcademyLoginUrl {\n  account {\n    promptinguLoginUrl\n  }\n}\n"